import { useLingui } from '@lingui/react';
import { Grid, Group, Tabs } from '@mantine/core';
export const ProfileTab: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Group justify="center">
      <Tabs.List w={878}>
        <Grid gutter={{
        base: 10,
        md: 22
      }}>
          <Grid.Col span={{
          base: 4,
          sm: 2
        }}>
            <Tabs.Tab value="overview" w={{
            base: '100%',
            sm: 112,
            md: 128
          }}>
              {i18n._('Overview')}
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={{
          base: 4,
          sm: 2
        }}>
            <Tabs.Tab value="vip" w={{
            base: '100%',
            sm: 112,
            md: 128
          }}>
              {i18n._('Vip Status')}
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={{
          base: 4,
          sm: 2
        }}>
            <Tabs.Tab value="stats" w={{
            base: '100%',
            sm: 112,
            md: 128
          }}>
              {i18n._('Stats')}
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={{
          base: 4,
          sm: 2
        }}>
            <Tabs.Tab value="transaction" w={{
            base: '100%',
            sm: 112,
            md: 128
          }}>
              {i18n._('Transactions')}
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={{
          base: 4,
          sm: 2
        }}>
            <Tabs.Tab value="referrals" w={{
            base: '100%',
            sm: 112,
            md: 128
          }}>
              {i18n._('Referrals')}
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={{
          base: 4,
          sm: 2
        }}>
            <Tabs.Tab value="account" w={{
            base: '100%',
            sm: 112,
            md: 128
          }}>
              {i18n._('Account')}
            </Tabs.Tab>
          </Grid.Col>
        </Grid>
      </Tabs.List>
    </Group>;
};